export const SOURCE_LIST = [
  {
    id: 'TIKTOK',
    name: 'Tiktok',
  },
  {
    id: 'FACEBOOK',
    name: 'Facebook',
  },
  {
    id: 'INSTAGRAM',
    name: 'Instagram',
  },
];

export const PAGINATION_CONVERT = {
  PAGE_SIZE: 10,
  PAGE_FIRST: 0,
};
